import React from 'react';
import WithAccordion from '../customComponents/CustomAccordion';
import Border, { IBorderValueProps } from '../../puck/reusable-props/Border';
import PaddingComponent from '../customComponents/PaddingComponent';
import NewMarginFiled from '../../puck/reusable-props/newMarginField';
import { MarginProps } from '../../puck/reusable-props/NewMargin';
import { PaddingProps } from '../../puck/reusable-props/padding';
import { Switch } from '@mui/material';
import QuillFieldRenderer from '../carousel review/QuillFieldRenderer';
import BackgroungColorComponent from '../customComponents/BackgroungColorComponent';

export interface IDisplayAfterShippingFormIsFilled
  extends MarginProps,
    PaddingProps {
  isDisplayAfterShippingFormIsFilled: boolean;
  text: string;
  background: {
    color: string;
    isInherit: boolean;
  };
  border: IBorderValueProps;
}

interface DisplayAfterShippingFieldProps {
  value: IDisplayAfterShippingFormIsFilled;
  onChange: (_value: IDisplayAfterShippingFormIsFilled) => void;
}

const DisplayAfterShippingField: React.FC<DisplayAfterShippingFieldProps> = ({
  value,
  onChange,
}) => {
  return (
    <WithAccordion title="Display After Shipping Form Is Filled">
      <div className="flex justify-between items-center mb-3">
        <p className="text-sm font-semibold">Show Text</p>
        <div className="flex gap-0.5 items-center">
          <Switch
            checked={value?.isDisplayAfterShippingFormIsFilled}
            onChange={e =>
              onChange({
                ...value,
                isDisplayAfterShippingFormIsFilled: e.target.checked,
              })
            }
          />
        </div>
      </div>
      {value?.isDisplayAfterShippingFormIsFilled && (
        <>
          <BackgroungColorComponent
            value={value?.background}
            onChange={val => {
              onChange({
                ...value,
                background: val,
              });
            }}
            title="Background Color"
          />
          <NewMarginFiled
            value={value?.margin}
            onChange={val => {
              onChange({
                ...value,
                margin: val,
              });
            }}
            title="Margin"
          />
          <PaddingComponent
            value={value?.padding}
            onChange={val => {
              onChange({
                ...value,
                padding: val,
              });
            }}
            title="Padding"
          />
          <Border
            value={value?.border}
            onChange={val => {
              onChange({
                ...value,
                border: val,
              });
            }}
            title="Border"
          />
          <QuillFieldRenderer
            label="Text"
            value={value?.text}
            onChange={val => {
              onChange({
                ...value,
                text: val,
              });
            }}
            id={2}
          />
        </>
      )}
    </WithAccordion>
  );
};

export default DisplayAfterShippingField;
